import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_CLIENT_API()+'auth/bilety/';
let URLHOST = AppConfig.HOST_API()+"bilety/"

export default {

    pobierzBiletyJednorazoweDanegoKlienta(idKl, page,size) {
        return axios({
            method: 'get',
            url: URL + 'byKlient/'+idKl+"?page="+page+"&size="+size+"&sort=wazny_od,desc"
        });
    },

    pobierzBiletyMiesieczneDanegoKlienta(idKl) {
        return axios({
            method: 'get',
            url: URL + 'miesieczne/byKlient/'+idKl,
        });
    },

    pobierzKartyDanegoKlienta(idKl) {
        return axios({
            method: 'get',
            url: URL + 'miesieczne/karty/byKlient/'+idKl,
        });
    },

    pobierzBiletyMiesieczneNaKarcie(idKa) {
        return axios({
            method: 'get',
            url: URLHOST + 'miesieczne/byKarta/'+idKa,
        });
    },

}


// WEBPACK FOOTER //
// ./src/modules/klienciConfig/KlienciBiletyService.js